import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN' // 引入中文文件
Validator.addLocale(zh)
const config = {
    locale: 'zh_CN',
    fieldsBagName: 'fieldBags'
}
Vue.use(VeeValidate, config)

// 自定义validate
const dictionary = {
    zh_CN: {
        messages: {
            required: (field) => '请输入',
            number: (field) => field + '必须为数值',
            url: () => '请输入正确格式的服务器地址',
            ip: () => '请输入正确的IP地址',
        },
        attributes: {
            ip: '输入IP地址',
            httpPort: '输入HTTP端口',
            username: '输入用户昵称',
            cardNumber: '请输入证件号码',
            phone: '输入手机号码',
            emailAdd: '输入邮件地址',
            authCode: '输入您收到的验证码',
            loginPwd: '输入登录密码（6~18位',
            traderpwd: '输入交易密码（6~18位',
            recommender: '输入您的推荐人',
            isSee: '阅读用户协议，并同意',
            npwdLog: '输入新的登录密码',
            qrwdLog: '输入确认登录密码'
        }
    }
}
Validator.updateDictionary(dictionary)

// 1.IPV4地址
Validator.extend('ipAddr', {
    messages: {
        zh_CN: field => '请输入正确的IPV4地址'
    },
    validate: value => {
        return /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/.test(value)
    }
})

// 2.端口【0~65535】
Validator.extend('port', {
    messages: {
        zh_CN: field => '请输入正确格式的端口号'
    },
    validate: value => {
        return /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(value)
    }
})

// 3.用户昵称
Validator.extend('name', {
    messages: {
        zh_CN: field => '姓名只能中文或英文'
    },
    validate: value => {
        return /^[\u4e00-\u9fa5A-Za-z]*$/.test(value)
    }
})

// 4.手机号码
Validator.extend('phone', {
    messages: {
        zh_CN: field => '手机号格式不正确'
    },
    validate: value => {
        return /^1[2-9]\d{9}$/.test(value)
    }
})

// 5.邮箱
Validator.extend('email', {
    messages: {
        zh_CN: field => '邮箱格式不正确'
    },
    validate: value => {
        return /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/.test(value)
    }
})

// 6.验证码
Validator.extend('code', {
    messages: {
        zh_CN: field => '验证码格式不正确'
    },
    validate: value => {
        return /^[0-9a-zA-Z]*$/.test(value)
    }
})

// 6.登录密码
Validator.extend('logpwd', {
    messages: {
        zh_CN: field => '登录密码格式不正确'
    },
    validate: value => {
        return /^\S{6,18}$/.test(value)
    }
})

// 7.交易密码
Validator.extend('tradpwd', {
    messages: {
        zh_CN: field => '交易密码格式不正确'
    },
    validate: value => {
        return /^\S{6,18}$/.test(value)
    }
})

// 8.推荐人
Validator.extend('recom', {
    messages: {
        zh_CN: field => '推荐人格式不正确'
    },
    validate: value => {
        return /^[^\u4e00-\u9fa5]{0,}$/.test(value)
    }
})

// 9.用户协议
Validator.extend('see', {
    messages: {
        zh_CN: field => '请阅读用户协议，并同意'
    },
    validate: value => {
        return true
    }
})

// 10.忘记密码，新的登录密码
Validator.extend('npwd', {
    messages: {
        zh_CN: field => '登录密码格式不正确[6~18位]'
    },
    validate: value => {
        return /^\S{6,18}$/.test(value)
    }
})

// 11.忘记密码，确认新的登录密码
Validator.extend('qrwd', {
    messages: {
        zh_CN: field => '登录密码格式不正确[6~18位]'
    },
    validate: value => {
        return /^\S{6,18}$/.test(value)
    }
})

//身份证校验
Validator.extend('idcard', {
    messages: {
        zh_CN: field => '身份证不正确'
    },
    validate: value => {
        return  /(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)
    }
})

//驾驶证校验
/** 正则表达式：验证驾驶证 12位数字 */
Validator.extend('drivecard', {
    messages: {
        zh_CN: field => '驾驶证不正确'
    },
    validate: value => {
        return /^[A-Za-z0-9]*$/.test(value)
        // return  /^\d{12}$/.test(value)
    }
})

//港澳居民通行证
 /** 正则表达式：验证港澳居民通行证 H/M + 10位或8位数字 */
Validator.extend('hkcard', {
    messages: {
        zh_CN: field => '通行证不正确'
    },
    validate: value => {
        return /^[A-Za-z0-9]*$/.test(value)
        // return  /^[HMhm]{1}(([0-9]{8})|([0-9]{10}))$/.test(value)
    }
})

//护照
 /** 正则表达式：验证护照 数字+字母，共9位 */
Validator.extend('passportcard', {
    messages: {
        zh_CN: field => '护照不正确'
    },
    validate: value => {
        return /^[A-Za-z0-9]*$/.test(value)
        // return  /^([a-zA-z]|[0-9]){9}$/.test(value)
    }
})

//台胞证
 /** 正则表达式：验证护照 数字+字母，共9位 */
 Validator.extend('twcard', {
    messages: {
        zh_CN: field => '台胞证不正确'
    },
    validate: value => {
        // return  /^[a-zA-Z][0-9]{9}$/.test(value)
        return /^[A-Za-z0-9]*$/.test(value)
    }
})



// WEBPACK FOOTER //
// ./src/assets/validate.js